import { render, staticRenderFns } from "./BldrComponentElement.vue?vue&type=template&id=124f42ec"
import script from "./BldrComponentElement.vue?vue&type=script&lang=js"
export * from "./BldrComponentElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports